import api from 'api/api'

export type DirectUploadKind = 'image' | 'video' | 'audio' | 'file' | 'recording'

export type DirectUploadOptions = {
    answerId?: string | null
    uploadKind: DirectUploadKind | string
    source: string
    onProgress?: (pct: number) => void
    registerCancel?: (fn: () => void) => void
}

export async function uploadFileDirectly(
    file: File,
    options: DirectUploadOptions,
): Promise<string> {
    const media = await api.preuploadAnswerMedia(
        { files: [file] },
        options.onProgress,
        options.registerCancel,
        {
            answerId: options.answerId || undefined,
            uploadKind: 'file',
            source: options.source,
        },
    )
    const signedId = media?.files?.[0]
    if (!signedId) throw new Error('Direct upload returned no file id')
    return signedId
}

export async function uploadRecordingDirectly(
    file: File,
    options: DirectUploadOptions,
): Promise<string> {
    const media = await api.preuploadAnswerMedia(
        { recording: file },
        options.onProgress,
        options.registerCancel,
        {
            answerId: options.answerId || undefined,
            uploadKind: 'recording',
            source: options.source,
        },
    )
    if (!media?.recording) throw new Error('Direct recording upload returned no file id')
    return media.recording
}
